<div class="flex flex-col gap-4">

  <div class="flex justify-between items-center">
    <h1 class="text-xl font-bold text-gray-800">
      პროდუქტები
    </h1>
    <button
      nz-button
      nzType="primary"
      nzSize="large"
      (click)="addRealization()"
      [disabled]="visitAddFacade.isCompleted"
      >
      <i nz-icon nzType="plus"></i>
      დამატება
    </button>
  </div>

  @for (realization of realizations(); track realization) {
    <nz-card>
      <div class="flex flex-col gap-4">
        @if (realization.employeeId) {
          <div nz-row nzJustify="space-between">
            <div nz-col class="flex gap-2">
              <div>
                თანამშრომელი: {{ realization.employee?.user?.fullName }}
              </div>
              <div>
                @if (realization.salaryPercent) {
                  <nz-divider nzType="vertical"></nz-divider>
                  <nz-tag nzColor="default">{{ realization.salaryPercent }}%</nz-tag>
                }
                @if (realization.salaryFixed) {
                  <nz-divider nzType="vertical"></nz-divider>
                  <nz-tag nzColor="default">{{ realization.salaryFixed }}
                    <i class="lari lari-c"></i>
                  </nz-tag>
                }
              </div>
            </div>
          </div>
        }
        @if (realization.product) {
          <div nz-row nzJustify="space-between">
            <div nz-col>
              <div>
                {{ realization.product?.name }}
              </div>
              @if (realization.gram) {
                <div>
                  {{ realization.gram }} გრამი
                </div>
              }

              @if (realization.quantity) {
                <div>
                  {{ realization.quantity }} ცალი
                </div>
              }
            </div>
            <div nz-col class="flex items-center">
              <div class="flex gap-1 items-center">
                @if (+realization.discountPrice > 0) {
                  <div class="flex items-center gap-1">
                    <i
                      nz-icon
                      nzType="money-collect"
                      nzTheme="outline"
                      style="color: #1890ff"
                    ></i>
                    <div>
                      {{ realization.discountPrice }} <i class="lari lari-c"></i>
                    </div>
                    <del>{{ realization.price }} <i class="lari lari-c"></i></del>
                  </div>
                }
                @if (+realization.discountPrice <= 0) {
                  <div>
                    <i
                      nz-icon
                      nzType="money-collect"
                      nzTheme="outline"
                      style="color: #1890ff"
                    ></i>
                    {{ realization.price }} <i class="lari lari-c"></i>
                  </div>
                }
              </div>


            </div>
          </div>



          @if (realization.employeeId && !realization.salaryPercent && !realization.salaryFixed) {
            <nz-alert nzType="warning"
              nzMessage="პროცედურაში არ არის მითითებული ხელფასის პროცენტი ან ფიქსირებული"
            [nzShowIcon]="true"></nz-alert>
          }
        } @else {
          <nz-alert nzType="error"
            nzMessage="პროცედურა არ არის მითითებული"
            [nzShowIcon]="true"
            [nzAction]="actionTemplate1"
          ></nz-alert>
          <ng-template #actionTemplate1>
            <button nz-button nzType="primary" (click)="addRealization(realization)">
              დამატება
            </button>
            </ng-template
            >
          }
          <div>
            <nz-space [nzSize]="16">
              <button
                *nzSpaceItem
                (click)="addRealization(realization)"
                nz-button
                nzSize="small"
                nzType="text"
                [disabled]="visitAddFacade.isCompleted"
                >
                <i
                  nz-icon
                  nzType="edit"
                  nzTheme="outline"
                  style="cursor: pointer"

                ></i>
              </button>
              @if (visitAddFacade.status !== 2) {
                <button
                  *nzSpaceItem
                  nz-popconfirm
                  nzPopconfirmTitle=" {{ 'buttons.deletePop' | translate }}"
                  nzPopconfirmPlacement="bottom"
                  (nzOnConfirm)="deleteRealization(realization)"
                  nz-button
                  nzDanger
                  nzSize="small"
                  nzType="text"
                  [disabled]="visitAddFacade.isCompleted"
                  >
                  <i nz-icon nzType="delete"></i>
                </button>
              }
            </nz-space>
          </div>
        </div>
      </nz-card>
      } @empty {
      <nz-empty></nz-empty>
    }
  </div>
